import { useMutation } from "@tanstack/react-query"
import { api } from "@/api/instance"

/**
 * Server-side rename/delete for audio records that already have a file_id.
 * Local-only pending recordings stay in useAudioRecordings (IndexedDB/jotai).
 */
export function useAudioRecordMutations() {
  const { mutateAsync: renameRecord, isPending: isRenaming } = useMutation({
    mutationFn: async ({
      profileId,
      fileId,
      name,
    }: {
      profileId: string
      fileId: string
      name: string
    }) => {
      await api.v1.renameRecord(fileId, profileId, { name })
      return { profileId, fileId, name }
    },
  })

  const { mutateAsync: deleteRecord, isPending: isDeleting } = useMutation({
    mutationFn: async ({
      profileId,
      fileId,
    }: {
      profileId: string
      fileId: string
    }) => {
      await api.v1.deleteRecord(fileId, profileId)
      return { profileId, fileId }
    },
  })

  return { renameRecord, deleteRecord, isRenaming, isDeleting }
}
